import React, { createContext, useContext, useEffect, useState } from 'react';

const STORAGE_KEY = 'appTheme';

const VALID_THEMES = ['light', 'dark', 'neutral'];

const ThemeContext = createContext(null);

function getStoredTheme() {
  if (typeof window === 'undefined') return 'light';
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (VALID_THEMES.includes(stored)) return stored;
  } catch (_) {}
  return 'light';
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(getStoredTheme);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('dark', 'theme-neutral');

    if (theme === 'dark') {
      root.classList.add('dark');
    } else if (theme === 'neutral') {
      root.classList.add('theme-neutral');
    }

    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (_) {}
  }, [theme]);

  const setTheme = (value) => {
    if (VALID_THEMES.includes(value)) {
      setThemeState(value);
    }
  };

  /** Raccourci historique : bascule uniquement entre clair et sombre (ignore neutral). */
  const toggleTheme = () => {
    setThemeState((prev) => {
      if (prev === 'dark') return 'light';
      if (prev === 'neutral') return 'dark';
      return 'dark';
    });
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}
